<template>
	<TopHeader />
	<router-view />
	<Footer />
</template>
